// extracted by mini-css-extract-plugin
export default {"preloader":"styles_preloader__U4gm2","spinner":"styles_spinner__R2sIY","spin":"styles_spin__XxyJa"};